import type {
  OnboardingStep,
  OnboardingStore,
} from "../context/OnboardingContext";

export const onboardingStepsLabels: { step: OnboardingStep; label: string }[] =
  [
    {
      step: "source",
      label: "1/12 Create your profile",
    },
    {
      step: "sector",
      label: "2/12 Choose your sector",
    },
    {
      step: "skills",
      label: "3/12 Add your skills",
    },
    {
      step: "job_title",
      label: "4/12 Add your job title",
    },
    {
      step: "experience",
      label: "5/12 Add your experience",
    },
    {
      step: "education",
      label: "6/12 Add your education",
    },
    {
      step: "locale",
      label: "7/12 Add your locale",
    },
    {
      step: "summary",
      label: "8/12 Add your summary",
    },
    {
      step: "pricing",
      label: "9/12 Pricing",
    },
    {
      step: "info",
      label: "10/12 Add your info",
    },
    {
      step: "online-presence",
      label: "11/12 Online presence",
    },
    {
      step: "review",
      label: "12/12 Review",
    },
  ];

/**
 * A fresh `sector` section (freelancer-categories D5). A factory, not a shared
 * object: the store mutates what it is given.
 */
export const createDefaultSector = (): OnboardingStore["sector"] => ({
  value: {
    job_category: null,
    job_category_secondary: null,
    job_subcategories: [],
  },
  source: null,
  reviewed: false,
  error: null,
});

export const commonSkills = [
  "International Development",
  "Product Development",
  "Web Development",
  "Smartphone",
  "Construction Document Preparation",
  "Specifications",
  "Mobile Game",
  "Android App Development",
  "App Development",
  "iOS Development",
  "UI/UX Design",
  "Project Management",
  "Quality Assurance",
  "DevOps",
  "Technical Writing",
];
